/* eslint-disable react/no-multi-comp */
import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { css } from "@jsUtils"
import { ContactForm } from "@shared"
import { PageSection } from "../PageSection"

// eslint-disable-next-line no-unused-vars
import Styles from "./contactFormFeature.module.scss"

/**
 * Contact Form Feature Section
 * @param {object} props - React props
 */
const ContactFormFeature = props => {
  const { theme, images } = props
  const [ready, setReady] = React.useState(false)

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <div className={Styles.sectionLeft}>
        <ContactForm
          id="contact-form-feature-module"
          captchaMsg
          portalId="20465501"
          formId="907052b6-79ed-433a-86c3-cb6199abb684"
        />
      </div>
      <div className={Styles.sectionRight}>
        <div className={Styles.imagesLeft}>
          {images[0] ? (
            <div className={Styles.imageWrapper}>
              <Img className={Styles.image} fluid={images[0].fluid} title={images[0].title} />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={Styles.imagesRight}>
          {images[1] ? (
            <div className={Styles.imageWrapper}>
              <Img className={Styles.image} fluid={images[1].fluid} title={images[1].title} />
            </div>
          ) : (
            ""
          )}
          {images[2] ? (
            <div className={Styles.imageWrapper}>
              <Img className={Styles.image} fluid={images[2].fluid} title={images[2].title} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </PageSection>
  )
}

export default ContactFormFeature
